import { getServiceUrl } from '../sysconfig';

/**
 * Build a URL for launching the Survey Explorer.
 * Resolves the cross-origin Explorer service URL from sysconfig.
 * @param {{ surveyId?: string, deploymentId?: string, tab?: string, userId?: string }} params
 * @returns {Promise<string>}
 */
export async function buildExplorerUrl({ surveyId, deploymentId, tab = 'explore', userId } = {}) {
    const base = (await getServiceUrl('explorer')) || '';
    if (!base) throw new Error('Survey Explorer URL not configured in sysconfig');
    const params = new URLSearchParams();
    if (tab) params.set('tab', tab);
    if (surveyId) params.set('surveyId', surveyId);
    if (deploymentId) params.set('deploymentId', deploymentId);
    if (userId) params.set('userId', userId);
    const qs = params.toString();
    return qs ? `${base}?${qs}` : base;
}

/**
 * Resolve the Explorer URL and open it, reusing the existing Explorer tab if one
 * is already open. Uses a fixed window name ('CloudSamExplorer') so the browser
 * focuses the existing tab on a repeat click instead of opening a duplicate,
 * matching the Designer's behavior ('CloudSamDesigner').
 * @param {{ surveyId?: string, deploymentId?: string, tab?: string, userId?: string }} params
 * @returns {Promise<void>}
 */
export async function openExplorer(params = {}) {
    const url = await buildExplorerUrl(params);
    window.open(url, 'CloudSamExplorer');
}

/**
 * Get the most recently viewed deployment from localStorage.
 */
export function getLastViewedDeployment(userId) {
    try {
        if (userId) {
            const raw = localStorage.getItem(`console.explorer.lastDeployment.${userId}`);
            if (raw) return JSON.parse(raw);
        }
        const raw = localStorage.getItem('console.explorer.lastDeployment');
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}
